import { Controller } from "stimulus";
import { useMutation } from 'stimulus-use'

export default class extends Controller {
  static targets = ['form']
  connect() {
    this.preview = this.element.querySelector('.website-previewer iframe').contentWindow;
    this.setupTextUpdateListener('#website_name', '[data-preview=name]')
    this.setupTextUpdateListener('#website_email', '[data-preview=email]')
    this.setupTextUpdateListener('#website_phone', '[data-preview=phone]')
    this.setupTextUpdateListener('#website_draft_info', '[data-preview=info]')
    this.setupTextUpdateListener('#website_info', '[data-preview=info]')
    this.setupTextUpdateListener('#website_address_attributes_address_line', '[data-preview=address]')
    this.setupTextUpdateListener('#website_address_attributes_country_id', '[data-preview=country]')
    this.setupTextUpdateListener('#website_address_attributes_city', '[data-preview=city]')
    this.setupTextUpdateListener('#website_address_attributes_postal_code', '[data-preview=postal_code]')
    this.setupTextUpdateListener('#website_draft_name', '[data-preview=name]')
    this.setupTextUpdateListener('#website_draft_email', '[data-preview=email]')
    this.setupTextUpdateListener('#website_draft_phone', '[data-preview=phone]')
    this.setupTextUpdateListener('#website_draft_website_address', '[data-preview=website_address]')
    this.setupTextUpdateListener('#website_website_address', '[data-preview=website_address]')
    this.setupTextUpdateListener('#website_draft_address_attributes_address_line', '[data-preview=address]')
    this.setupTextUpdateListener('#website_draft_address_attributes_country_id', '[data-preview=country]')
    this.setupTextUpdateListener('#website_draft_address_attributes_city', '[data-preview=city]')
    this.setupTextUpdateListener('#website_draft_address_attributes_postal_code', '[data-preview=postal_code]')
    useMutation(this, {subtree: true, attributes: true, childList: true})
    this.updatePreview();
  }

  mutate(entries) {
    this.updatePreview()
    for (let record of entries) {
      if (record.target.id == 'website_address_attributes_latitude' || record.target.id == 'website_address_attributes_longitude') {
        let latitude = this.element.querySelector('#website_address_attributes_latitude').value
        let longitude = this.element.querySelector('#website_address_attributes_longitude').value
        this.preview.postMessage({action: 'website_preview:update_image', target: '[data-preview=static-map]', value: `https://maps.googleapis.com/maps/api/staticmap?zoom=16&size=640x300&markers=color:red%7Clabel:C%7C${latitude},${longitude}&key=AIzaSyDpXHAD5rNTIbaD5W-E7aXrWiub7f0-3pU`})
      }

      if (record.target.id == 'website_draft_address_attributes_latitude' || record.target.id == 'website_draft_address_attributes_longitude') {
        let latitude = this.element.querySelector('#website_draft_address_attributes_latitude').value
        let longitude = this.element.querySelector('#website_draft_address_attributes_longitude').value
        this.preview.postMessage({action: 'website_preview:update_image', target: '[data-preview=static-map]', value: `https://maps.googleapis.com/maps/api/staticmap?zoom=16&size=640x300&markers=color:red%7Clabel:C%7C${latitude},${longitude}&key=AIzaSyDpXHAD5rNTIbaD5W-E7aXrWiub7f0-3pU`})
      }

      if (record.target.classList.contains('gallery-images')) {
        let images = [...record.target.querySelectorAll('.image-preview')].map((el) => el.src)
        this.preview.postMessage({action: 'website_preview:update_slider', target: '[data-preview=gallery]', value: images})
      }
    }
  }

  updatePreview(e) {
    if (this.element.querySelector('.image-field .preview img')) {
      this.preview.postMessage({action: 'website_preview:update_image', target: '[data-preview=cover-image]', value: this.element.querySelector('.image-field .preview img').src})
    }
  }

  setupTextUpdateListener(inputSelector, targetSelector) {
    let input = this.element.querySelector(inputSelector)
    if (input) {
      input.addEventListener('input', (e) => {
        this.preview.postMessage({action: 'website_preview:update_text', target: targetSelector, value: input.value})
      })

      input.addEventListener('trix-change', (e) => {
        this.preview.postMessage({action: 'website_preview:update_text', target: targetSelector, value: input.value})
      })


      input.addEventListener('paste', (e) => {
        this.preview.postMessage({action: 'website_preview:update_text', target: targetSelector, value: input.value})
      })

      input.addEventListener('change', (e) => {
        this.preview.postMessage({action: 'website_preview:update_text', target: targetSelector, value: input.value})
      })
    }
  }

  async galleryUpload(e) {
    e.preventDefault();
    const urlToObject = async(src, filename) => {
      const response = await fetch(src);
      const blob = await response.blob();
      console.log(blob);
      const file = new File([blob], filename, {type: blob.type});
      return file;
    }

    let container = new DataTransfer(); 
    let uploadedImages = document.getElementById("uploaded-images");
    var children = uploadedImages.querySelectorAll(".image-content");
    let position = {};
    let count = 0;

    for (const node of children) {
      const src = node.firstElementChild.src;
      const filename = node.getElementsByTagName('p')[0].innerText;

      if(node.firstElementChild.id == "pexel"){
        const result = await urlToObject(src, filename);
        container.items.add(result);
      }else if(node.firstElementChild.id != ""){
        position[count] = node.firstElementChild.id;
      }else{
        const result = this.dataURLtoFile(src, filename);
        container.items.add(result);
      }
      count++;
    }

    document.getElementById("position").value = JSON.stringify(position);
    let deletedImages = document.getElementById("deleted-image-ids");
    let arrayOfDeletedImages = deletedImages.value.split(",");
    arrayOfDeletedImages.pop();
    deletedImages.value = arrayOfDeletedImages;
    let images = document.getElementById("images");
    images.files = container.files;
    this.formTarget.submit();
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);

    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {type:mime});
  }
}
